import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import {
  getContentGroup,
  safeGTag,
} from '@utils/analytics';
import { getAnalyticConfigs, useCatalogRouteMatch } from '@utils/common';
import { useAppContext } from '@contexts/AppContext';
import { useIsAuthQuery } from '@hook/useIsAuth/graphql.v4.generated';

export const useGTagConfigEffect = () => {
  const location = useLocation();
  const catalogMatch = useCatalogRouteMatch();
  const { isOutlet, isBot } = useAppContext();

  const { data: authData, loading } = useIsAuthQuery({
    context: {
      v4: true,
      ignoreAuthError: true,
    },
    skip: (
      // Skip if non full SPA page
      // or Bot
      typeof window !== 'undefined' && window.BASE_TEMPLATE_SOURCE !== 'ssr'
      || isBot
    ),
  });

  const contentGroup = getContentGroup(location.pathname);
  const namespace = catalogMatch?.params?.namespace;
  const viewer = authData?.viewer;
  const {
    gtagId,
    googleAdsIds,
  } = getAnalyticConfigs(isOutlet);

  // Initilize GA4
  useEffect(
    () => {
      if (window.BASE_TEMPLATE_SOURCE === 'ssr' && !loading) {
        if (gtagId) {
          safeGTag(
            // @ts-ignore
            'config',
            gtagId,
            {
              groups: 'GA4',
              content_group: contentGroup,
              ...(namespace ? { namespace } : {}),
              ...(viewer ? { user_id: `${viewer.id}` } : {}),
            },
          );
        }

        if (googleAdsIds?.length) {
          googleAdsIds.map((id) => {
            safeGTag(
              // @ts-ignore
              'config',
              id,
              { groups: 'Google_ads' },
            );
          });
        }
      }
    },
    [contentGroup, namespace, viewer, loading, isOutlet, googleAdsIds, gtagId],
  );
};
